import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Shield, ArrowLeft, Loader, CheckCircle, AlertCircle } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const res = await fetch(`${BACKEND_URL}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (res.ok) setSent(true);
      else setError("Something went wrong. Please try again.");
    } catch {
      setError("Unable to connect. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-12 h-12 bg-navy rounded-xl flex items-center justify-center mx-auto mb-4">
            <Shield className="w-6 h-6 text-white" />
          </div>
          <h1 className="font-heading font-bold text-slate-800 text-2xl">Reset your password</h1>
          <p className="text-slate-500 text-sm mt-1">Enter your email and we'll send a reset link</p>
        </div>

        {sent ? (
          <div className="bg-white rounded-xl border border-slate-200 p-6 text-center shadow-sm">
            <CheckCircle className="w-10 h-10 text-green-500 mx-auto mb-3" />
            <p className="font-semibold text-slate-800 mb-1">Check your inbox</p>
            <p className="text-slate-500 text-sm">If that email is registered, you'll receive a reset link shortly.</p>
            <Link to="/login" className="inline-block mt-4 text-navy text-sm font-medium hover:underline">Back to login</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-600 mb-1.5">Email address</label>
              <input required type="email" value={email} onChange={e => setEmail(e.target.value)}
                placeholder="you@company.com" data-testid="forgot-email"
                className="w-full h-10 px-3 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-navy/30 focus:border-navy" />
            </div>
            {error && <div className="flex items-center gap-2 text-red-600 text-sm"><AlertCircle className="w-4 h-4" />{error}</div>}
            <button type="submit" disabled={loading} data-testid="forgot-submit"
              className="w-full h-10 flex items-center justify-center gap-2 bg-navy text-white rounded-lg text-sm font-semibold hover:bg-navy-dark transition-colors disabled:opacity-60">
              {loading ? <Loader className="w-4 h-4 animate-spin" /> : null}
              {loading ? "Sending..." : "Send Reset Link"}
            </button>
            <Link to="/login" className="flex items-center justify-center gap-1.5 text-sm text-slate-500 hover:text-navy transition-colors">
              <ArrowLeft className="w-3.5 h-3.5" /> Back to login
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
